import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { BetterEnrichAdmin } from '@/features/betterenrich-admin'

const betterenrichSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(20),
  filter: z.string().optional().catch(''),
  status: z.array(z.string()).optional(),
})

export type BetterEnrichSearchParams = z.infer<typeof betterenrichSearchSchema>

export const Route = createFileRoute('/_authenticated/admin/betterenrich')({
  validateSearch: betterenrichSearchSchema,
  component: BetterEnrichAdmin,
})
